module.exports = __webpack_public_path__ + "06_mole.fb6bfd1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer2/06_mole.png
// module id = fFVG
// module chunks = 0